import axios from 'axios';
import { DOMAIN, API_V1 } from '@/common/agent/ApiAgent';

const URL_PATH_SIGNIN = '/users/signin';
export type SignInResponseData = {
  access_token: string;
  access_token_expires_at: string;
  token_type: string;
};

export enum LoginErrorCode {
  LoginIdNotFound = 'login/login_id',
  PasswordIncorrect = 'login/password',
}
export type LoginError = {
  detail: {
    code: LoginErrorCode;
    message: string;
  };
};

const signin = async (loginId: string, password: string) =>
  axios.post<SignInResponseData>(
    DOMAIN + API_V1 + URL_PATH_SIGNIN,
    new URLSearchParams({
      username: loginId,
      password,
    }),
    { withCredentials: true },
  );

export default signin;
